import { ApiResponse } from "../utils/api/ApiProps";

import { ModulesApiData, ModulesDetail ,CreateModuleRequest} from "../types/settings/ModuleTypes";

import api from "../utils/api";

// interface Module {
//   uuid: string;
//   module_name: string;
//   module_created_date: string;
// }

interface GetModuleParams {
  page?: number;
  search_term?: string;
 sort_column?:string
  sort_order?: "ASC" | "DESC";
}


export const getModules = async ({
  page = 1,
  search_term = "",
  sort_column,
  sort_order,
}: GetModuleParams = {}): Promise<ApiResponse<ModulesApiData>> => {
  const searchParams = new URLSearchParams();

  searchParams.append("page", page.toString());
  if (search_term) searchParams.append("search_term", search_term);
  if (sort_column) searchParams.append("sort_column", sort_column);
  if (sort_order) searchParams.append("sort_order", sort_order);

  const queryString = searchParams.toString();
  const url = queryString ? `/modules?${queryString}` : "/modules";

  return api.get<ModulesApiData>(url);
};




export const getModuleById = async (
  uuid: string
): Promise<ApiResponse<{ data: ModulesDetail }>> => {
  try {
    return await api.req<{ data: ModulesDetail }>({
      url: `/modules/${uuid}`,
      method: api.Method.GET,
    });
  } catch (error) {
    // console.error(`Error fetching user ${uuid}:`, error);
    throw new Error(`Failed to fetch module details for ${uuid}`);
  }
};

export const deleteModule = async (
  uuid: string
  // data: any
): Promise<ApiResponse<{ data: any }>> => {
  const response = await api.req<any>({
    url: `/modules/${uuid}`,
    method: api.Method.DELETE,
    // body: data,
  });
  return response;
};



export const createModule = async (
  data: CreateModuleRequest
): Promise<ApiResponse<{ data: ModulesDetail }>> => {
  try {
    const response = await api.req<{ data: ModulesDetail }>({
      url: "/modules",
      method: api.Method.POST,
      body: data,
    });

    if (response.status !== "success") {
      throw new Error(response.message || "Failed to create module");
    }

    return response;
  } catch (error: any) {
    // console.error("Error creating user:", error);
    throw new Error(error);
  }
};

export const updateModule = async (
  uuid: string,
  data: CreateModuleRequest
): Promise<ApiResponse<{ data:ModulesDetail }>> => {
  try {
    const response = await api.req<{ data: ModulesDetail }>({
      url: `/modules/${uuid}`,
      method: api.Method.POST,
      body: data,
    });

    if (response.status !== "success") {
      throw new Error(response.message || "Failed to update module");
    }

    return response;
  } catch (error) {
    console.error(`Error updating module${uuid}:`, error);
    throw new Error("Failed to update module");
  }
};












